<template>
	<v-layout row wrap>

		<financial-table-element
			xs="11"
			lighten="1"
			text="Suma kosztów programowych"
		></financial-table-element>

		<FinancialTableElement
			xs="1"
			lighten="1"
			:text="formatMoney(totalActions)"
		></FinancialTableElement>

	</v-layout>
</template>

<script>
	import FinancialTableElement from "../FinancialTableRowElement";
	import {Numbers} from "../../../../../utils/Numbers";

	export default {
		name: "SumOfActions",
		components: {FinancialTableElement},
		props: {
			totalActions: {},
		},
		mixins: [Numbers],
	};
</script>

<style scoped>

</style>